module.exports = __webpack_public_path__ + "static/krishna-5144c7510e23b22ac33d1cd9fab05aca.jpg";